<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :item-value="itemValue"
    :item-text="itemText"
    :error="getError"
    :error-messages="getErrorContents"
    :label="label"
    :rules="getRules"
    :prepend-inner-icon="iconLeft"
    :append-icon="iconRight"
    :outlined="outlined"
    :disabled="disabled"
    :readonly="readonly"
    :filter="customFilter"
    :return-object="isObject"
    @change="$emit('input', $event)"
    @input="$emit('selected', $event)"
    no-data-text="Nenhum item encontrado"
  >
    <template v-slot:item="{ item }">
      <p class="ed-table-info">
        {{ item[itemText] }}
        <label v-if="item.contato_documento">
          <b>DOCUMENTO:</b>
          {{ $utilidade.mascara(item.contato_documento, item.contato_documento.length == 11 ? "cpf" : "cnpj") }}
        </label>
        <label v-if="item.parent_contato_nome">
          <b>EMPRESA:</b>
          {{ item.parent_contato_nome }}
        </label>
      </p>
    </template>

    <template v-slot:append-outer v-if="!!$slots.addonRight">
      <slot name="addonRight"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
import EdFormMixin from "./mixins/formControl";

export default {
  name: "EdInputAutoComplete",
  mixins: [EdFormMixin],
  components: {},
  props: {
    items: {
      type: [Array],
      required: false,
      default: function () {
        return [];
      },
    },
    itemValue: {
      type: [String, Function],
      required: false,
      default: "id",
    },
    itemText: {
      type: [String, Number, Function],
      required: false,
      default: "nome",
    },
    itemAddTitle: {
      type: String,
      default: "Adicionar item",
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      search: null,
      timerId: null,
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    customFilter(item, queryText, itemText) {
      const textOne = this.$utilidade.removerAcentos(item[this.itemText]).toLowerCase();
      const searchText = this.$utilidade.removerAcentos(queryText).toLowerCase();

      return !searchText || textOne.indexOf(searchText) > -1;
    },
  },
  watch: {
    items() {},
    search(val) {
      clearTimeout(this.timerId);

      this.timerId = setTimeout(() => {
        this.$emit("search", val);
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/template/EdInputAutoComplete.vue